// Light/dark theme toggle. The initial theme is applied before paint by an
// inline script in layout/theme.liquid (reads localStorage, defaults to dark).
// This file handles the toggle button and persistence.

function setTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  try {
    localStorage.setItem('theme', theme);
  } catch (e) {}
}

if (!window.__themeToggleBound) {
  window.__themeToggleBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-theme-toggle]') : null;
    if (!button) return;

    const current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    setTheme(current === 'dark' ? 'light' : 'dark');
  });
}
